import { nostojs } from "@nosto/nosto-js"
import { Config } from "../config"

function notImplemented(): string | undefined {
    throw new Error("Not implemented")
}

export const tagging = {
    categoryId: notImplemented,
    categoryPath: notImplemented,
    pageType: notImplemented,
    variation: notImplemented,
    brand: notImplemented
}

nostojs(api => {
    tagging.categoryId = () => api.pageTagging().categoryIds?.[0]
    tagging.categoryPath = () => api.pageTagging().categories?.[0]
    tagging.pageType = () => api.pageTagging().pageType
    tagging.variation = () => api.pageTagging().variation
    tagging.brand = () => api.pageTagging().brands?.[0]
})

export function registerSearchTermsProvider(config: Pick<Config, "serpUrlMapping" | "inputCssSelector">) {
    nostojs(api => {
        api.internal.setTaggingProvider(
            "searchTerms",
            () => {
                const params = new URLSearchParams(window.location.search)
                const queryValue = params.get(config.serpUrlMapping?.query || "")
                return queryValue ? [queryValue] : undefined
            },
            { priority: true }
        )
    })
}
